module.exports = __webpack_public_path__ + "static/img/img_cat_thanks.1d9a877.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_thanks.png
// module id = 53
// module chunks = 1